import { ValidationError } from './service-error.model';
export class ReservationValidationError extends ValidationError {
  validationErrorCode: string;
  messageErrorCode: string;

  constructor(validationErrorCode: string, messageErrorCode: string, details?: any) {
    super(details);
    this.validationErrorCode = validationErrorCode;
    this.messageErrorCode = messageErrorCode;
  }
}

export class ReservationAvailabilityError extends ReservationValidationError {
  private _hasError: boolean;
  private _invalidGuests: boolean;
  private _invalidDates: boolean;
  private _invalidRooms: boolean;
  private _componentLevelMessage: boolean;

  constructor(validationErrorCode: string, messageErrorCode: string, invalidGuests?: boolean, invalidDates?: boolean, invalidRooms?: boolean) {
    super(validationErrorCode, messageErrorCode);
    this.invalidGuests = invalidGuests;
    this.invalidDates = invalidDates;
    this.invalidRooms = invalidRooms;
  }

  get hasError(): boolean {return this._hasError}

  get invalidGuests(): boolean {return this._invalidGuests}

  set invalidGuests(invalidGuests: boolean) {
    this._invalidGuests = invalidGuests;
    if (invalidGuests) {
      this._hasError = invalidGuests;
    }
  }

  get invalidDates(): boolean {return this._invalidDates}

  set invalidDates(invalidDates: boolean) {
    this._invalidDates = invalidDates;
    if (invalidDates) {
      this._hasError = invalidDates;
    }
  }

  get invalidRooms(): boolean {return this._invalidRooms}

  set invalidRooms(invalidRooms: boolean) {
    this._invalidRooms = invalidRooms;
    if (invalidRooms) {
      this._hasError = invalidRooms;
    }
  }
}

export class ReservationAuthorizationError extends ReservationValidationError {
  constructor(validationErrorCode: string, messageErrorCode?: string) {
    super(validationErrorCode, messageErrorCode);
  }
}

export class ReservationForbiddenError extends ReservationAvailabilityError {
    constructor(validationErrorCode: string, messageErrorCode: string, invalidGuests?: boolean, invalidDates?: boolean, invalidRooms?: boolean) {
        super(validationErrorCode, messageErrorCode, invalidGuests, invalidDates, invalidRooms);
    }
}

export class OverrideReservationGuestError extends ReservationValidationError {
  constructor(validationErrorCode?: string, messageErrorCode?: string) {
    super(validationErrorCode, messageErrorCode);
  }
}

export class InvalidReservationError extends ReservationValidationError {
  constructor(message: string) {
    super('invalidReservation', message);
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/errors/reservation-error.model.ts